import { CHF01_IMAGES } from 'data/images/chf01/default'
import { CHM01_IMAGES } from 'data/images/chm01/default'
import { F01_IMAGES } from 'data/images/f01/default'
import { F01_MEMOJI_OLDER_IMAGES } from 'data/images/f01/memoji-older'
import { M01_IMAGES } from 'data/images/m01/default'
import { M01_MEMOJI_DARK_IMAGES } from 'data/images/m01/memoji-dark'
import { M01_MEMOJI_OLDER_IMAGES } from 'data/images/m01/memoji-older'
import { M01_REALISTIC_IMAGES } from 'data/images/m01/realistic'
import { MILICAF01_IMAGES } from 'data/images/milicaf01/default'
import { MILICAM01_IMAGES } from 'data/images/milicam01/default'
import { SHARED_IMAGES } from 'data/images/shared/default'
import { TCHM01_IMAGES } from 'data/images/tchm01/default'
import { WALLPIF01_IMAGES } from 'data/images/wallpif01/default'
import { WALLPIF01_MEMOJI_OLDER_IMAGES } from 'data/images/wallpif01/memoji-older'
import type { ImagesDefinition } from 'types/images'
import type { Funnel } from 'types/state'

type FunnelVariants = Record<string, ImagesDefinition> & {
  default: ImagesDefinition
}

export const DEFAULT_IMAGE_VARIANT = 'default'

export const ALL_IMAGES = {
  chf01: { default: CHF01_IMAGES },
  chm01: { default: CHM01_IMAGES },
  f01: {
    default: F01_IMAGES,
    memojiOlder: F01_MEMOJI_OLDER_IMAGES,
  },
  hopif01: {
    default: F01_IMAGES,
    memojiOlder: F01_MEMOJI_OLDER_IMAGES,
  },
  m01: {
    default: M01_IMAGES,
    memojiDark: M01_MEMOJI_DARK_IMAGES,
    memojiOlder: M01_MEMOJI_OLDER_IMAGES,
    realistic: M01_REALISTIC_IMAGES,
  },
  milicaf01: { default: MILICAF01_IMAGES },
  milicam01: { default: MILICAM01_IMAGES },
  shared: { default: SHARED_IMAGES },
  tchm01: { default: TCHM01_IMAGES },
  wallpif01: {
    default: WALLPIF01_IMAGES,
    memojiOlder: WALLPIF01_MEMOJI_OLDER_IMAGES,
  },
} as const satisfies Record<Funnel, FunnelVariants> &
  Record<string, FunnelVariants>
